export default "__VITE_ASSET__Cpl1sAMr__"